"use client";

import { useScrollReveal } from "~/src/components/common/useScrollReveal";

type RevealSectionProps = {
  className?: string;
  children: React.ReactNode;
};

/**
 * スクロールで画面内に入ったら16px下から上方向へフェードインするラッパー。
 * prefers-reduced-motion: reduce では useScrollReveal 側で即座に表示済み状態になる。
 */
export default function RevealSection({ className = "", children }: RevealSectionProps) {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`transition-[opacity,transform] duration-[800ms] ease-[cubic-bezier(0.2,0.7,0.3,1)] motion-reduce:transition-none ${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
      } ${className}`}
    >
      {children}
    </div>
  );
}
